// https://www.builder.io/c/docs/custom-react-components
import { builder, Builder } from '@builder.io/react';

// Import builder component config files
import './components/section/section.builder';
import './components/block/block.builder';
import './components/slider/slider.builder';

import './components/buttons/buttons.builder';
import './components/text/text.builder';
import './components/image/image.builder';
import './components/table/table.builder';

import './components/embedMedia/embedMedia.builder';
import './components/embedCustom/embedCustom.builder';

// Initialize builder with API Key
builder.init('e8f38c59369349348e1e8ceb60b6b986');

// Override default component menu, removes built-in builder components
const OVERRIDE_INSERT_MENU = false;
Builder.set({ customInsertMenu: OVERRIDE_INSERT_MENU });

// Define Builder menu and components
// New components added to the project must be imported and added here for editors to access them
Builder.register('insertMenu', {
  name: 'Layout Components',
  items: [{ name: 'Section' }, { name: 'Block' }, { name: 'Slider' }],
});

Builder.register('insertMenu', {
  name: 'Content Components',
  items: [
    { name: 'Text' },
    { name: 'Buttons' },
    { name: 'Image' },
    { name: 'Table' },
  ],
});

Builder.register('insertMenu', {
  name: 'Embed Components',
  items: [{ name: 'Embed Media' }, { name: 'Embed Custom' }],
});
